import { RealTimeAction } from '@/_core/fluxstore/types';
import { StorymapState } from '../../types';
import { useStorymapStore } from '../../useModule';
import { useSendCommand } from '@/_core/cqrs/use';
import { ChangeStorymapCardDefaultColors } from '../../../api/commands';

const { registerReducer, registerMiddleware } = useStorymapStore();

export class ChangeTaskColor extends RealTimeAction<StorymapState> {
    public static ACTION_TYPE = 'ChangeTaskColor';

    public constructor(public color: number) {
        super(ChangeTaskColor.ACTION_TYPE);
    }
}

const middleware = async (state: StorymapState, action: ChangeTaskColor): Promise<boolean> => {
    useSendCommand(action, {
        createCommand: () => new ChangeStorymapCardDefaultColors(state.id, state.activityColor, action.color, state.subtaskColor),
    });

    return true;
};

const reducer = (state: StorymapState, action: ChangeTaskColor): void => {
    state.taskColor = action.color;
};

//@ts-ignore
registerMiddleware(ChangeTaskColor.ACTION_TYPE, middleware);

//@ts-ignore
registerReducer(ChangeTaskColor.ACTION_TYPE, reducer);
